import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import styled from '../../../../theme/theme';

interface WrapperProps {
  isEmbeddedMobile: boolean;
}

export const Wrapper = styled(Box)<WrapperProps>(({ theme, isEmbeddedMobile }) => ({
  display: 'none',

  [`@media only screen and (min-width: ${isEmbeddedMobile ? theme.breakpoints[0] : '0px'})`]: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.space[16],
  },
}));
